module.exports = __webpack_public_path__ + "media/icons/caret-round-48135708.svg";